import React from 'react';
import { 
  Box, 
  Container, 
  Typography, 
  Button, 
  Paper,
  useTheme,
  useMediaQuery
} from '@mui/material';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Legal = () => {
  const { t } = useLanguage();
  const theme = useTheme();

  return (
    <Box component="main" sx={{ flexGrow: 1 }}>
        <Header />
        <Box>
            <Container maxWidth="lg">
                <br/>
                <Typography variant="h1">{t('contact.title')}</Typography>
                <Typography variant="body1">
                {t('contact.contact')} {t('contact.email')}
                <br/>
                </Typography>
                <Typography variant="body1"><br/></Typography>
            </Container>
        </Box>
        <Footer />
    </Box>
  );
};

export default Legal;